module.exports = __webpack_public_path__ + "img/main-banner.c8ae1790.svg";